import React from "react";
import { Helmet } from "react-helmet-async";

import styles from "./Home.css";
import { environment } from "../../config/environment";
import { GridCell } from "../../atoms/Layout/GridCell/GridCell";
import { GridRow } from "../../atoms/Layout/GridRow/GridRow";
import { DesktopQuery, MobileQuery } from "../../atoms/Layout/Responsive";
import { Categories, Pages } from "../../constants/Pages";
import { Game } from "../../models/Game";
import { User } from "../../models/User";
import { HomePageSorting } from "../../models/HomePageSorting";
import { HaveQuestions } from "../../molecules/HaveQuestions/HaveQuestions";
import {
  PromoCarousel,
  PromoEvent,
} from "../../molecules/PromoCarousel/PromoCarousel";
import { RecentlyPlayedGames } from "../../molecules/Recomendations/RecentlyPlayed";
import { Recommendations as Recs } from "../../molecules/Recomendations/Recommendations";
import { RightRail } from "../../molecules/RightRail/RightRail";
import { PageService } from "../../services/PageService";
import AARPAdUnitsMeta from "../../services/AARPAdUnitsMeta";
import { Analytics } from "../../services/Analytics/Analytics";
import { BadgeService } from "../../services/BadgeService";
import { Block } from "../../atoms/Layout/Block/Block";
import { homePageStructuredData } from "../../constants/SchemasSEO";

type HomeProps = {
  games: Game[];
  user: User;
  homePageSorting: HomePageSorting[];
  promo: PromoEvent[];
};

export const HomeCategories: Categories[] = [
  Categories.Members,
  Categories.Mahjongg,
  Categories.Solitaire,
  Categories.Word,
  Categories.Arcade,
  Categories.Juegos,
];

export class HomeTemplate extends React.PureComponent<HomeProps> {
  state = {
    url: "",
  };

  componentDidMount() {
    this.setState({ url: window.location.href });
    BadgeService.updateBadgeStatus();
    Analytics.trackEvent(Analytics.general.promoBox(HomeCategories.join("|")));
  }

  render() {
    const { games, user, promo } = this.props;
    const pageSEO = PageService.getPageSEO(Pages.Home);
    //! If update this component
    //! Change the pageChangedDate for new current date
    const pageChangedDate = new Date("2022-12-07T10:52:01.670Z").toISOString();
    const schemaData = homePageStructuredData(
      this.state.url,
      pageSEO.MetaHTMLTitle,
      pageSEO.MetaHTMLDescription,
      pageChangedDate
    );

    return (
      <React.Fragment>
        <Helmet
          htmlAttributes={{ lang: "en-US" }}
          title={pageSEO.MetaHTMLTitle}
          meta={[
            { name: "description", content: pageSEO.MetaHTMLDescription },
            { name: "robots", content: "index,follow" },
            { property: "og:title", content: pageSEO.OgTitle },
            { property: "og:description", content: pageSEO.OgDescription },
            ...AARPAdUnitsMeta.homepage(),
          ]}
          link={[{ rel: "canonical", href: environment.PROD_HOST + "/" }]}
        >
          <script type="application/ld+json">
            {JSON.stringify(schemaData)}
          </script>
        </Helmet>

        <PromoCarousel games={games} promoEvents={promo} />

        <GridRow className={styles.wrapperRow}>
          <CategoriesColumn size={[8, 12]}>
            <Block paddingB="xxl">
              {HomeCategories.map((category, i) =>
                this.renderCategory(category, i)
              )}
            </Block>

            <RecentlyPlayed games={games} user={user} />
            <DesktopQuery>
              <HaveQuestions />
            </DesktopQuery>
          </CategoriesColumn>

          <DesktopQuery>
            <GridCell size={[4, 12]} direction="column">
              <RightRail mode="Home" topGap={true} />
            </GridCell>
          </DesktopQuery>
        </GridRow>
        <MobileQuery>
          <RightRail mode="Home" topGap={true} />
          <HaveQuestions />
        </MobileQuery>
      </React.Fragment>
    );
  }

  renderCategory = (category, i) => {
    const { homePageSorting } = this.props;

    const sorting = homePageSorting.find(
      (gcSorting) => gcSorting.category === category
    );
    if (!sorting) return;

    // Filter final array to prevent null or undefined elements, which may cause error
    const games = sorting.games
      .map((sortedSlug) =>
        this.props.games.find((game) => game.slug === sortedSlug)
      )
      .filter((game) => !!game);

    return (
      <Recommendations
        key={i}
        title={category}
        viewMoreLink={`/category/${
          PageService.getPageSEO(category as any).URLAlias
        }`}
        description={`${category} category`}
        games={games}
      />
    );
  };
}

const CategoriesColumn = (props: any) => (
  <GridCell className={styles.categoriesColumn} {...props} />
);
const Recommendations = (props: any) => (
  <Recs className={styles.recommendations} {...props} />
);
const RecentlyPlayed = (props: any) => (
  <RecentlyPlayedGames className={styles.recentlyPlayed} {...props} />
);
